/**
 * Converts a given set of fields into a format accepted by a `FormattedField`
 * 
 * @param {Object}  fields 
 * @returns {Object}
 */
const mapIntoFormattedFields = (fields) => {
    return Object.keys(fields)
        .map((fieldName) => ({
            id         : fieldName,
            name       : fields[fieldName].label,
            field_type : {
                value: fields[fieldName].field_type
            },
            type: {
                value: fields[fieldName].type ?? 'text'
            },
            disabled         : fields[fieldName].disabled ?? false,
            confirmed        : fields[fieldName].confirmed ?? false,
            required         : fields[fieldName].required ?? false,
            if               : fields[fieldName].if ?? (() => true),
            additional_props : fields[fieldName]?.additional_props ?? {},

            tooltip: fields[fieldName]?.tooltip ?? null,

            ...fields[fieldName]?.field_type === 'dropdown'
                ? {
                    options: fields[fieldName]?.options 
                        ? mapEnumArray(fields[fieldName].options ?? [])
                        : undefined,
                    url      : fields[fieldName]?.url,
                    config   : fields[fieldName]?.config ?? {},
                    multiple : fields[fieldName]?.multiple ?? false,
                    errors   : fields[fieldName]?.errors
                } : {},

            ...fields[fieldName]?.field_type === 'address-lookup'
                ? {
                    fieldConfig: fields[fieldName]?.fieldConfig ?? {}
                } : {}
        }))
}

/**
 * Converts an enum into the format required by the formatted field select element
 * 
 * @param {Array} data 
 * @returns {Array<Number, Object>}
 */
const mapEnumArray = data => Array.isArray(data)
    ? data.map(mapEnum)
    : data

const mapEnum = option => option instanceof Object 
    ? {
        ...option,
        id     : option.value ?? option.id,
        option : option.label ?? option.name
    } : null

/**
 * Converts an enum API response into a format accepted by the formatted field
 * 
 * @param {Object} data 
 * @returns {Object}
 */
const parseEnumApiResponse = data => ({
    ...data,
    data: mapEnumArray(data.data)
})

export {
    mapEnum,
    mapEnumArray,
    mapIntoFormattedFields,
    parseEnumApiResponse
}